export default "__VITE_ASSET__k2IBNO2o__"